
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'academy-achievements-public-ui',
  currentProjectVersion: 'static-1.497',
  depVersions: {
  "academy-achievements-public-ui": "static-1.497",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.496",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8313",
  "hubspot-dlb": "static-2.1882",
  "react-dlb": "static-1.88",
  "academy-common-lib": "static-1.14932",
  "academy-navigation-lib": "static-1.2327",
  "analytics_js": "static-1.4460",
  "apollo-stack-hubspot": "static-3.84",
  "avatar-components": "static-1.2766",
  "classnames": "static-2.10",
  "data-fetching-client": "static-1.9937",
  "enviro": "static-4.455",
  "foundations-assets": "static-1.5164",
  "foundations-components": "static-1-ech-accordiontransition-jank.30",
  "foundations-theming": "static-1.4753",
  "graphql": "static-1.87",
  "hub-http": "static-1.6493",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11767",
  "I18n": "static-7.1669",
  "quartz": "static-1.7432",
  "quartz-config": "static-1.1210",
  "quartz-core": "static-1.6651",
  "quartz-routing": "static-1.862",
  "quartz-tracking": "static-1.811",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-aeastham-wv-soft-nav-lcp-field-cleanup.2",
  "rpc-client-utils": "static-1.4946",
  "signup-constants": "static-1.19590",
  "styled-components": "static-2.95",
  "trellis-ecosystem": "static-1.7600",
  "ui-addon-i18n": "static-1.11427",
  "UIComponents": "static-3.8713",
  "viral-links-lib": "static-1.7356",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3606",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3709",
  "quartz-webpack": "static-1.3656",
  "bend-plugin-quartz-routing": "static-1.510",
  "HeadJS": "static-2.794",
  "framer-motion": "static-1.77",
  "hs-test-utils-bend-plugin": "static-1.3424",
  "msw": "static-1.39",
  "testing-library": "static-1.157",
  "webpack-env": "static-1.54",
  "academy-service-client": "static-1.3968",
  "ai-components-ui-library": "static-1.9671",
  "copilot-toolkit": "static-1.11817",
  "croppie": "static-2.10",
  "cssUtils": "static-1.901",
  "feedback-loader": "static-1.29780",
  "FileManagerCore": "static-1.39942",
  "FileManagerLib": "static-1.40083",
  "final-form": "static-1.76",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.30",
  "foundations-theming-specialty": "static-1.2469",
  "hs-lodash": "static-4.45",
  "hs-story-utils": "static-1.9706",
  "HubStyle": "static-2.12074",
  "icons": "static-2.678",
  "immer": "static-1.99",
  "magpie-lib": "static-1.5739",
  "markdown-it": "static-1.6",
  "navigation-components": "static-1.18786",
  "navigation-messaging": "static-1.8113",
  "onboarding-tours": "static-1.17088",
  "PatternValidationJS": "static-1.3175",
  "quick-fetch": "static-1.4117",
  "react-utils": "static-2.5542",
  "SafeStorage": "static-1.4683",
  "sanitize-text": "static-1.8434",
  "sassPrefix": "static-1.173",
  "SharedI18nStrings": "static-1.182",
  "StyleGuideUI": "static-3.501",
  "ui-addon-react-router-dom": "static-1.9818",
  "ui-addon-video-player": "static-1.8983",
  "ui-fonts": "static-1.1029",
  "ui-images": "static-2.1239",
  "usage-tracker-container": "static-1.7626",
  "usage-tracker-core": "static-1.7486",
  "video-embed": "static-1.36610",
  "wootric-nps": "static-1.7186",
  "zustand": "static-1.83",
  "storybook-react": "static-1.38",
  "hub-http-janus": "static-1.875",
  "hub-http-shared-msw-handlers": "static-1.10583",
  "hubspotter-http": "static-1.4850",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.30",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.71",
  "react-create-root-preference": "static-1.68",
  "react-select-plus": "static-1.110",
  "react-virtualized": "static-2.105",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2587",
  "bend-plugin-foundations-theming": "static-1.3236",
  "foundations-theming-base": "static-1.3738",
  "stylex": "static-1.39",
  "hs-locale-management": "static-1.279",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.89",
  "jasmine": "static-4.4594",
  "jasmine-runner": "static-1.6733",
  "opentelemetry-fe-types": "static-1.50",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.31",
  "opentelemetry-fe": "static-1.425",
  "quartz-auth": "static-1.1107",
  "quartz-head": "static-1.1097",
  "quartz-i18n": "static-1.1107",
  "quartz-test": "static-1.1107",
  "trellis-components": "static-1.2606",
  "usage-tracker-session-replay": "static-1.5322",
  "csstype": "static-1.50",
  "web-vitals": "static-1.13",
  "bend-plugin-chirp-manifest": "static-1.356",
  "chirp-fetch": "static-1.2175",
  "marketplace-ui-apps-core": "static-1.19219",
  "marketplace-ui-common": "static-1.20687",
  "trellis-story-utils": "static-1.4789",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.30",
  "react-input-autosize": "static-2.17",
  "signup-ui-url-generator": "static-2.8342",
  "bender-build-tools": "static-1.3425",
  "ts-schema": "static-1.4279",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22897",
  "ContentUtils": "static-1.69087",
  "customer-data-objects-ui-components": "static-1.13312",
  "sanitize": "static-1.4754",
  "breeze-engine-lib": "static-1.1678",
  "magpie-types": "static-1.5199",
  "simple-logging-lib": "static-1.3331",
  "breeze-artifacts-sdk": "static-1.272",
  "audio-components": "static-1.6315",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.24443",
  "FileManagerImages": "static-1.37594",
  "html-to-image": "static-1.59",
  "immerable": "static-1.4430",
  "react-colorpicker": "static-2.10496",
  "redux-toolkit": "static-1.76",
  "reselect": "static-3.10",
  "salesImages": "static-1.544",
  "ui-universal-auth": "static-1.9365",
  "urlinator": "static-1.4813",
  "usage-tracker": "static-1.7636",
  "video-components": "static-1.14120",
  "video-data-lib": "static-1.35776",
  "redux-thunk": "static-2.78",
  "idb-keyval": "static-1.49",
  "reactive-lib": "static-1.1000",
  "nest": "static-1.516",
  "getting-started-shared-tasks": "static-1.19196",
  "growth-data-modal": "static-1.5865",
  "growth-onboarding-confetti": "static-1.3342",
  "growth-onboarding-next-action-utils": "static-1.2651",
  "onboarding-tours-client": "static-1.5303",
  "onboarding-tours-utils": "static-1.1155",
  "ui-shepherd-react": "static-3.10549",
  "ui-shepherd-tracker": "static-1.7930",
  "user-context": "static-1.5399",
  "transmute": "static-2.85",
  "outpost": "static-1.4438",
  "stylex-utils": "static-1.138",
  "trellis-theming": "static-1.1255",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10581",
  "base-ui": "static-1.20",
  "react-day-picker": "static-1.8",
  "tanstack-virtual": "static-1.36",
  "amplitude-session-replay-browser": "static-1.60",
  "developer-experience-shared-components": "static-1.10785",
  "immutable-less": "static-1.4930",
  "marketplace-ui-client-types": "static-1.18094",
  "ui-addon-iframeable": "static-1.9358",
  "ui-addon-integrations-directory-panel": "static-2.8306",
  "ui-extensibility-client-types": "static-1.4198",
  "ai-settings-ui-library": "static-1.8295",
  "integrations-lib": "static-1.16991",
  "laboratory-lib": "static-3.7431",
  "nav-meta": "static-1.30423",
  "react-window": "static-1.13",
  "superstore": "static-1.5037",
  "ui-addon-upgrades": "static-9.18355",
  "ui-product-approvals-common": "static-1.985",
  "cms-field-types": "static-1.5095",
  "content-icons-ui": "static-1.2344",
  "underscore": "static-1.8",
  "atom": "static-1.5366",
  "customer-data-objects": "static-1.7971",
  "customer-data-ui-utilities": "static-1.10109",
  "property-translator": "static-1.5678",
  "reference-resolvers": "static-1.8462",
  "breeze-engine-chat-components": "static-1.656",
  "breeze-engine-core": "static-1.956",
  "ably": "static-2.2",
  "highlight.js": "static-1.84",
  "content-assistance-lib": "static-1.8173",
  "apollo-link-hub-http": "static-2.4936",
  "video-components-external": "static-1.12118",
  "unified-auth-core-lib": "static-1.1161",
  "social-insights-client-types": "static-1.22700",
  "onboarding-data-sync-lib": "static-1.2476",
  "growth-onboarding-next-action-components": "static-1.2679",
  "user-context-client": "static-1.4789",
  "getting-started-shared-tasks-store": "static-1.18314",
  "apps-service-types": "static-1.4020",
  "inbound-db-meta-service-client": "static-1.3718",
  "oauth-service-types": "static-1.4518",
  "simple-data-table": "static-1.3497",
  "flux-actions": "static-1.366",
  "frontend-preferences-client": "static-1.8203",
  "hs-promise-utils": "static-1.5877",
  "hubspot-apollo-client": "static-1.5159",
  "integrations-error-boundary-lib": "static-1.14406",
  "integrations-tracking-lib": "static-1.5889",
  "native-integrations-shared-strings": "static-1.8059",
  "redux-observable": "static-1.73",
  "ReduxMessenger": "static-2.10650",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.879",
  "merchandise-lib": "static-1.276",
  "purchase-motions-components": "static-1.6338",
  "inbound-db-properties-service-client": "static-1.4042",
  "react-dnd-compat": "static-1.4898",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "ui-coaching-tips": "static-1.29268",
  "content-media-composition-data-lib": "static-1.13197",
  "content-media-compositions": "static-2.17204",
  "media-bridge-lib": "static-1.19379",
  "fsm": "static-1.4030",
  "InboxConnectUtils": "static-4.15521",
  "meetings-connect-utils-lib": "static-1.7889",
  "onboarding-scopes": "static-1.6735",
  "hubspot-apollo-cache": "static-1.618",
  "universal-page-editor-lib": "static-1.3288",
  "adobe-sign-auth-lib": "static-1.425",
  "ads-unified-auth-lib": "static-1.1252",
  "google-sheets-integration-lib": "static-1.991",
  "microsoft-drive-auth-lib": "static-1.97",
  "surveymonkey-integration-lib": "static-1.434",
  "slack-ui-library": "static-1.10679",
  "purchase-motions-api": "static-1.6341",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "growth-onboarding-feedback-components": "static-1.6865",
  "js-cookie": "static-1.18",
  "hub-http-contrib": "static-1.3319",
  "ui-addon-sales-email": "static-1.5493",
  "crm-record-cards-service-types": "static-1.3772",
  "framework-data-schema-resolvers": "static-1.7173",
  "location-customization-utils-lib": "static-1.10060",
  "seat-types-lib": "static-1.678",
  "batch-promise": "static-1.1824",
  "conditional-properties-service-client": "static-1.3998",
  "crm-pipelines-api-client-types": "static-1.4333",
  "fdsr-migration-layer": "static-1.292",
  "framework-builder-read-service-client": "static-1.4207",
  "framework-data-schema-quick-fetch": "static-1.7078",
  "multi-currency-client-types": "static-1.3894",
  "persist-promise": "static-1.3981"
},
  depPathPrefixes: {
  "academy-achievements-public-ui": "/academy-achievements-public-ui/static-1.497",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.496",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8313",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "react-dlb": "/react-dlb/static-1.88",
  "academy-common-lib": "/academy-common-lib/static-1.14932",
  "academy-navigation-lib": "/academy-navigation-lib/static-1.2327",
  "analytics_js": "/analytics_js/static-1.4460",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "avatar-components": "/avatar-components/static-1.2766",
  "classnames": "/classnames/static-2.10",
  "data-fetching-client": "/data-fetching-client/static-1.9937",
  "enviro": "/enviro/static-4.455",
  "foundations-assets": "/foundations-assets/static-1.5164",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.30",
  "foundations-theming": "/foundations-theming/static-1.4753",
  "graphql": "/graphql/static-1.87",
  "hub-http": "/hub-http/static-1.6493",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11767",
  "I18n": "/I18n/static-7.1669",
  "quartz": "/quartz/static-1.7432",
  "quartz-config": "/quartz-config/static-1.1210",
  "quartz-core": "/quartz-core/static-1.6651",
  "quartz-routing": "/quartz-routing/static-1.862",
  "quartz-tracking": "/quartz-tracking/static-1.811",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-aeastham-wv-soft-nav-lcp-field-cleanup.2",
  "rpc-client-utils": "/rpc-client-utils/static-1.4946",
  "signup-constants": "/signup-constants/static-1.19590",
  "styled-components": "/styled-components/static-2.95",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7600",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11427",
  "UIComponents": "/UIComponents/static-3.8713",
  "viral-links-lib": "/viral-links-lib/static-1.7356",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3606",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3709",
  "quartz-webpack": "/quartz-webpack/static-1.3656",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.510",
  "HeadJS": "/HeadJS/static-2.794",
  "framer-motion": "/framer-motion/static-1.77",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3424",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.157",
  "webpack-env": "/webpack-env/static-1.54",
  "academy-service-client": "/academy-service-client/static-1.3968",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9671",
  "copilot-toolkit": "/copilot-toolkit/static-1.11817",
  "croppie": "/croppie/static-2.10",
  "cssUtils": "/cssUtils/static-1.901",
  "feedback-loader": "/feedback-loader/static-1.29780",
  "FileManagerCore": "/FileManagerCore/static-1.39942",
  "FileManagerLib": "/FileManagerLib/static-1.40083",
  "final-form": "/final-form/static-1.76",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.30",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2469",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-story-utils": "/hs-story-utils/static-1.9706",
  "HubStyle": "/HubStyle/static-2.12074",
  "icons": "/icons/static-2.678",
  "immer": "/immer/static-1.99",
  "magpie-lib": "/magpie-lib/static-1.5739",
  "markdown-it": "/markdown-it/static-1.6",
  "navigation-components": "/navigation-components/static-1.18786",
  "navigation-messaging": "/navigation-messaging/static-1.8113",
  "onboarding-tours": "/onboarding-tours/static-1.17088",
  "PatternValidationJS": "/PatternValidationJS/static-1.3175",
  "quick-fetch": "/quick-fetch/static-1.4117",
  "react-utils": "/react-utils/static-2.5542",
  "SafeStorage": "/SafeStorage/static-1.4683",
  "sanitize-text": "/sanitize-text/static-1.8434",
  "sassPrefix": "/sassPrefix/static-1.173",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9818",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8983",
  "ui-fonts": "/ui-fonts/static-1.1029",
  "ui-images": "/ui-images/static-2.1239",
  "usage-tracker-container": "/usage-tracker-container/static-1.7626",
  "usage-tracker-core": "/usage-tracker-core/static-1.7486",
  "video-embed": "/video-embed/static-1.36610",
  "wootric-nps": "/wootric-nps/static-1.7186",
  "zustand": "/zustand/static-1.83",
  "storybook-react": "/storybook-react/static-1.38",
  "hub-http-janus": "/hub-http-janus/static-1.875",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10583",
  "hubspotter-http": "/hubspotter-http/static-1.4850",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.30",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.71",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "react-select-plus": "/react-select-plus/static-1.110",
  "react-virtualized": "/react-virtualized/static-2.105",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2587",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3236",
  "foundations-theming-base": "/foundations-theming-base/static-1.3738",
  "stylex": "/stylex/static-1.39",
  "hs-locale-management": "/hs-locale-management/static-1.279",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.89",
  "jasmine": "/jasmine/static-4.4594",
  "jasmine-runner": "/jasmine-runner/static-1.6733",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.50",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.31",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.425",
  "quartz-auth": "/quartz-auth/static-1.1107",
  "quartz-head": "/quartz-head/static-1.1097",
  "quartz-i18n": "/quartz-i18n/static-1.1107",
  "quartz-test": "/quartz-test/static-1.1107",
  "trellis-components": "/trellis-components/static-1.2606",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5322",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.13",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.356",
  "chirp-fetch": "/chirp-fetch/static-1.2175",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19219",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20687",
  "trellis-story-utils": "/trellis-story-utils/static-1.4789",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.30",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8342",
  "bender-build-tools": "/bender-build-tools/static-1.3425",
  "ts-schema": "/ts-schema/static-1.4279",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22897",
  "ContentUtils": "/ContentUtils/static-1.69087",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13312",
  "sanitize": "/sanitize/static-1.4754",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1678",
  "magpie-types": "/magpie-types/static-1.5199",
  "simple-logging-lib": "/simple-logging-lib/static-1.3331",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.272",
  "audio-components": "/audio-components/static-1.6315",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.24443",
  "FileManagerImages": "/FileManagerImages/static-1.37594",
  "html-to-image": "/html-to-image/static-1.59",
  "immerable": "/immerable/static-1.4430",
  "react-colorpicker": "/react-colorpicker/static-2.10496",
  "redux-toolkit": "/redux-toolkit/static-1.76",
  "reselect": "/reselect/static-3.10",
  "salesImages": "/salesImages/static-1.544",
  "ui-universal-auth": "/ui-universal-auth/static-1.9365",
  "urlinator": "/urlinator/static-1.4813",
  "usage-tracker": "/usage-tracker/static-1.7636",
  "video-components": "/video-components/static-1.14120",
  "video-data-lib": "/video-data-lib/static-1.35776",
  "redux-thunk": "/redux-thunk/static-2.78",
  "idb-keyval": "/idb-keyval/static-1.49",
  "reactive-lib": "/reactive-lib/static-1.1000",
  "nest": "/nest/static-1.516",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19196",
  "growth-data-modal": "/growth-data-modal/static-1.5865",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3342",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2651",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5303",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1155",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10549",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7930",
  "user-context": "/user-context/static-1.5399",
  "transmute": "/transmute/static-2.85",
  "outpost": "/outpost/static-1.4438",
  "stylex-utils": "/stylex-utils/static-1.138",
  "trellis-theming": "/trellis-theming/static-1.1255",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10581",
  "base-ui": "/base-ui/static-1.20",
  "react-day-picker": "/react-day-picker/static-1.8",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10785",
  "immutable-less": "/immutable-less/static-1.4930",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18094",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9358",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8306",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4198",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8295",
  "integrations-lib": "/integrations-lib/static-1.16991",
  "laboratory-lib": "/laboratory-lib/static-3.7431",
  "nav-meta": "/nav-meta/static-1.30423",
  "react-window": "/react-window/static-1.13",
  "superstore": "/superstore/static-1.5037",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18355",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.985",
  "cms-field-types": "/cms-field-types/static-1.5095",
  "content-icons-ui": "/content-icons-ui/static-1.2344",
  "underscore": "/underscore/static-1.8",
  "atom": "/atom/static-1.5366",
  "customer-data-objects": "/customer-data-objects/static-1.7971",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10109",
  "property-translator": "/property-translator/static-1.5678",
  "reference-resolvers": "/reference-resolvers/static-1.8462",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.656",
  "breeze-engine-core": "/breeze-engine-core/static-1.956",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.84",
  "content-assistance-lib": "/content-assistance-lib/static-1.8173",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4936",
  "video-components-external": "/video-components-external/static-1.12118",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1161",
  "social-insights-client-types": "/social-insights-client-types/static-1.22700",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2476",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2679",
  "user-context-client": "/user-context-client/static-1.4789",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18314",
  "apps-service-types": "/apps-service-types/static-1.4020",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "oauth-service-types": "/oauth-service-types/static-1.4518",
  "simple-data-table": "/simple-data-table/static-1.3497",
  "flux-actions": "/flux-actions/static-1.366",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8203",
  "hs-promise-utils": "/hs-promise-utils/static-1.5877",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5159",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14406",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5889",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8059",
  "redux-observable": "/redux-observable/static-1.73",
  "ReduxMessenger": "/ReduxMessenger/static-2.10650",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.879",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "purchase-motions-components": "/purchase-motions-components/static-1.6338",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4042",
  "react-dnd-compat": "/react-dnd-compat/static-1.4898",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29268",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13197",
  "content-media-compositions": "/content-media-compositions/static-2.17204",
  "media-bridge-lib": "/media-bridge-lib/static-1.19379",
  "fsm": "/fsm/static-1.4030",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15521",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7889",
  "onboarding-scopes": "/onboarding-scopes/static-1.6735",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.618",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3288",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.425",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1252",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.991",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.97",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.434",
  "slack-ui-library": "/slack-ui-library/static-1.10679",
  "purchase-motions-api": "/purchase-motions-api/static-1.6341",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6865",
  "js-cookie": "/js-cookie/static-1.18",
  "hub-http-contrib": "/hub-http-contrib/static-1.3319",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5493",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3772",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7173",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10060",
  "seat-types-lib": "/seat-types-lib/static-1.678",
  "batch-promise": "/batch-promise/static-1.1824",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3998",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4333",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.292",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4207",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7078",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3894",
  "persist-promise": "/persist-promise/static-1.3981"
}
};
